import type { ShopifyAssetResponse } from '~/modules/shopify/types';
import type { ProviderSource, TemplateInfo } from './template';
import type { Campaign } from '~/modules/campaign/types';

export interface FetchThemePageProps {
  campaigns?: Campaign[];
  assets?: ShopifyAssetResponse;
}

export interface IThemePageBase {
  id: string;
  name: string;
  default: boolean;
  status: IThemePageStatus;
  updatedAt: string;
  publishedAt?: string | null;
  thumbnail: string;
  providerSource: ProviderSource;
}

export enum IThemePageStatus {
  DRAFT = 'DRAFT',
  NEED_PUBLISHING = 'NEED_PUBLISHING',
  PUBLISHED = 'PUBLISHED',
  PUBLISHING = 'PUBLISHING',
  PUBLISH_ERROR = 'PUBLISH_ERROR',
}
export enum IThemePageType {
  ARTICLE = 'ARTICLE',
  BLOG = 'BLOG',
  COLLECTION = 'COLLECTION',
  GP_ARTICLE = 'GP_ARTICLE',
  GP_BLOG = 'GP_BLOG',
  GP_COLLECTION = 'GP_COLLECTION',
  GP_FUNNEL_PAGE = 'GP_FUNNEL_PAGE',
  GP_INDEX = 'GP_INDEX',
  GP_PRODUCT = 'GP_PRODUCT',
  GP_STATIC = 'GP_STATIC',
  POST_PURCHASE = 'POST_PURCHASE',
  PRODUCT = 'PRODUCT',
  STATIC = 'STATIC',
  GP_PRE_SALE_PAGE = 'GP_PRE_SALE_PAGE',
}

export interface IThemePageInfo {
  templateInfo: TemplateInfo;
  label: IThemePageBase['name'];
  thumbnail: IThemePageBase['thumbnail'];
  default: IThemePageBase['default'];
  providerSource: IThemePageBase['providerSource'];
  defaultByProvider?: IThemePageBase['providerSource'];
  isHide?: boolean;
  isChildren?: boolean;
  updatedAt?: IThemePageBase['updatedAt'];
  themePageID?: string;
  status?: IThemePageStatus;
  publishedAt?: string | null;
}
